// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"16d3d9a5","142":"985ae1ec","162":"5d92478d","354":"ad96bfb0","498":"5d98f857","563":"d8956e43","716":"a1ec91f5"}[chunkId] + ".chunk.js";
};